export default {
	HIGHER_ED: 'higher-ed',
	K_12: 'K-12',
}
